import { render } from "./BlogGrid.vue?vue&type=template&id=e59ff89a"
import script from "./BlogGrid.vue?vue&type=script&lang=js"
export * from "./BlogGrid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__